import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "schedule-place"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "schedule-box",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.jumpPage && _ctx.jumpPage(...args)))
  }, [
    _createVNode(_component_Heading, { tag: "h3" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.title), 1)
      ]),
      _: 1
    }),
    (_ctx.$props.time)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`schedule-time day-${_ctx.$props.day}`)
        }, _toDisplayString(_ctx.$props.time), 3))
      : _createCommentVNode("", true),
    (_ctx.$props.place)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$props.place), 1))
      : _createCommentVNode("", true)
  ]))
}